<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
  messageDelay: {
    type: Number,
    default: 1,
  },
  delayUnit: {
    type: String,
    default: 'minutes',
  },
  delayVariationPercent: {
    type: Number,
    default: 0,
  },
  preventDuplicateContacts: {
    type: Boolean,
    default: true,
  },
  autoEnqueueByLabel: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const cadenceLabel = () => {
  const unitKey = `CAMPAIGN.WAHA.CREATE.FORM.CADENCE.UNIT_${props.delayUnit.toUpperCase()}`;
  const unit = t(unitKey);
  if (props.delayVariationPercent > 0) {
    return t('CAMPAIGN.WAHA.CARD.CADENCE_WITH_VARIATION', {
      delay: props.messageDelay,
      unit,
      variation: props.delayVariationPercent,
    });
  }
  return t('CAMPAIGN.WAHA.CARD.CADENCE', { delay: props.messageDelay, unit });
};
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.WAHA.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">
      {{ inboxName }}
    </span>
  </div>

  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.WAHA.CARD.CAMPAIGN_DETAILS.ON') }}
  </span>
  <span class="flex-1 text-sm font-medium truncate text-n-slate-12">
    {{ messageStamp(scheduledAt, 'LLL d, h:mm a') }}
  </span>

  <div class="flex items-center gap-2 mt-1 flex-wrap col-span-full">
    <span
      class="text-xs text-n-slate-10 bg-n-surface-2 px-2 py-0.5 rounded-full"
    >
      {{ cadenceLabel() }}
    </span>
    <span
      v-if="preventDuplicateContacts"
      class="text-xs text-n-teal-11 bg-n-teal-2 px-2 py-0.5 rounded-full"
    >
      {{ t('CAMPAIGN.WAHA.CARD.DEDUP_ACTIVE') }}
    </span>
    <span
      v-if="autoEnqueueByLabel"
      class="text-xs text-n-blue-11 bg-n-blue-2 px-2 py-0.5 rounded-full"
    >
      {{ t('CAMPAIGN.WAHA.CARD.AUTO_LABEL') }}
    </span>
  </div>
</template>
